/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { NgClass } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from "@angular/material/snack-bar";
import { ToastData } from "./toast-data.model";

@Component({
	selector: "globalictcc-toast",
	standalone: true,
	imports: [NgClass],
	templateUrl: "./toast.component.html",
	styleUrl: "./toast.component.scss"
})
export class ToastComponent {
	constructor(
		public snackBarRef: MatSnackBarRef<ToastComponent>,
		@Inject(MAT_SNACK_BAR_DATA) public data: ToastData
	) {}

	public get iconName(): string {
		switch (this.data.type) {
			case "success":
				return "info";
			case "warning":
				return "warning";
			case "error":
				return "close";
			default:
				return "info";
		}
	}

	public dismiss(): void {
		this.snackBarRef.dismiss();
	}
}
